import Objdict from "objdict"

import chalk from "chalk"

const betterValues = {
    "red": "#B9314F",
    "green": "#52B788"
}

export default class Prettylog {
    static style(components) {
        if(components instanceof Array == false) {
            components = [components]
        }
        if(typeof window != "undefined") {
            return Prettylog.browserstyle(components)
        } else {
            return Prettylog.terminalstyle(components)
        }
    }
    static browserstyle(components) {
        let text = ""
        const styles = []
        components.forEach((component) => {
            if(component == false
            || component.isSkipped) {
                return
            }
            if(text.length > 0) {
                text += "%c "
                styles.push("")
            }

            text += "%c"
            text += component.text

            if(component.style == undefined) {
                styles.push("")
            } else {
                let style = ""
                Objdict.forEach(component.style, (value, key) => {
                    value = betterValues[value] || value
                    style += key + ":" + value + ";"
                })
                styles.push(style)
            }
        })
        return [text].concat(styles)
    }
    static terminalstyle(components) {
        let text = ""
        components.forEach((component) => {
            if(component == false
            || component.isSkipped) {
                return
            }
            if(text.length > 0) {
                text += " "
            }

            let style = chalk
            if(component.style != undefined) {
                if(component.style["background-color"]) {
                    const color = component.style["background-color"]
                    style = style["bg" + color.charAt(0).toUpperCase() + color.slice(1)]
                }
                if(component.style["color"] != undefined) {
                    style = style[component.style["color"]]
                }
                if(component.style["font-weight"] == "bold") {
                    style = style["bold"]
                }
            }

            text += style(component.text)
        })
        return [text]
    }
}

// TODO: Structured grouping
// function consolegroup(logs = []) {
//     console.groupCollapsed(logs.shift())
//     while(log.length > 0) {
//         console.log(logs.shift())
//     }
//     console.groupEnd()
// }

// TODO: support for more console rendering, like images.
